export default {
  addEmulator(state, data) {
    state.emulators = state.emulators.concat(data)
  },
  setEmulators(state, data) {
    state.emulators = data
  },
}
